/* aia-grocery-request.js v2 — modals, state sync, map, submit */
(function () {
  'use strict';
  var cfg = JSON.parse(document.getElementById('gr-config').textContent);
  var $ = function (id) { return document.getElementById(id); };
  var rows = $('gr-rows'), tpl = $('gr-row-tpl'), form = $('gr-form'), err = $('gr-error');
  var DRAFT_KEY = 'aia_gr_draft_v1';
  var I = cfg.i18n || {};

  /* ---------- slots ---------- */
  (function () {
    var sel = $('gr-slot'), start = cfg.slotStart, end = cfg.slotEnd;
    var hours = end > start ? end - start : 24 - start + end;
    for (var i = 0; i < hours; i++) {
      var a = (start + i) % 24, b = (start + i + 1) % 24;
      var o = document.createElement('option');
      o.value = pad(a) + ':00-' + pad(b) + ':00';
      o.textContent = pad(a) + ':00 – ' + pad(b) + ':00';
      sel.appendChild(o);
    }
    var today = new Date().toISOString().slice(0, 10);
    $('gr-date').min = today;
    if (!$('gr-date').value) $('gr-date').value = today;
  })();
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- rows ---------- */
  function addRow(data) {
    var node = tpl.content.firstElementChild.cloneNode(true);
    var name = 'brand_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
    node.querySelectorAll('[data-f="brand"]').forEach(function (r) { r.name = name; });
    rows.appendChild(node);
    if (data) fillRow(node, data);
    syncRow(node);
    return node;
  }
  function fillRow(node, d) {
    node.querySelector('[data-f="category"]').value = d.category || '';
    node.querySelector('[data-f="product"]').value = d.product || '';
    node.querySelector('[data-f="amount"]').value = d.amount || '';
    node.querySelector('[data-f="unit"]').value = d.unit || 'kg';
    var b = node.querySelector('[data-f="brand"][value="' + (d.brand || 'any') + '"]'); if (b) b.checked = true;
    node.querySelector('[data-f="brand_name"]').value = d.brand_name || '';
  }
  function syncRow(node) {
    var hasCat = !!node.querySelector('[data-f="category"]').value;
    ['product', 'amount', 'unit'].forEach(function (f) { node.querySelector('[data-f="' + f + '"]').disabled = !hasCat; });
    var specific = node.querySelector('[data-f="brand"]:checked').value === 'specific';
    node.querySelector('[data-f="brand_name"]').hidden = !specific;
  }
  function readRow(node) {
    return {
      category: node.querySelector('[data-f="category"]').value,
      product: node.querySelector('[data-f="product"]').value.trim(),
      amount: node.querySelector('[data-f="amount"]').value,
      unit: node.querySelector('[data-f="unit"]').value,
      brand: node.querySelector('[data-f="brand"]:checked').value,
      brand_name: node.querySelector('[data-f="brand_name"]').value.trim()
    };
  }
  function items() { return Array.prototype.map.call(rows.children, readRow); }
  function completeItems() { return items().filter(function (i) { return i.category && i.product; }).map(function (i) { if (!i.amount) i.amount = '1'; return i; }); }

  rows.addEventListener('change', function (e) {
    var node = e.target.closest('[data-row]'); if (!node) return;
    syncRow(node); e.target.classList.remove('is-invalid'); saveDraft(); syncState();
  });
  rows.addEventListener('input', function () { saveDraft(); syncState(); });
  rows.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove]'); if (!btn) return;
    var node = btn.closest('[data-row]');
    if (rows.children.length > 1) node.remove(); else { fillRow(node, {}); syncRow(node); }
    saveDraft(); syncState();
  });
  $('gr-add').addEventListener('click', function () {
    var n = addRow(); n.querySelector('[data-f="category"]').focus(); saveDraft(); syncState();
  });

  /* ---------- draft ---------- */
  function collect() {
    return {
      items: items(),
      name: $('gr-name').value.trim(), email: $('gr-email').value.trim(),
      cc: $('gr-cc').value, phone: $('gr-phone').value.trim(),
      hotel: $('gr-hotel').value.trim(), date: $('gr-date').value,
      slot: $('gr-slot').value, note: $('gr-note').value.trim(),
      payment: (form.querySelector('[name="payment"]:checked') || {}).value || 'cash'
    };
  }
  function saveDraft() { try { localStorage.setItem(DRAFT_KEY, JSON.stringify(collect())); } catch (e) {} }
  function loadDraft() {
    try {
      var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null'); if (!d) return;
      (d.items || []).forEach(addRow);
      ['name', 'email', 'phone', 'hotel', 'note'].forEach(function (k) { if (d[k]) $('gr-' + k).value = d[k]; });
      if (d.cc) $('gr-cc').value = d.cc;
      if (d.date && d.date >= $('gr-date').min) $('gr-date').value = d.date;
      if (d.slot) $('gr-slot').value = d.slot;
      var p = form.querySelector('[name="payment"][value="' + d.payment + '"]'); if (p) p.checked = true;
    } catch (e) {}
  }
  loadDraft();
  if (!rows.children.length) addRow();
  form.addEventListener('input', saveDraft);
  form.addEventListener('change', saveDraft);

  /* ---------- state sync ---------- */
  var esc = function (t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; };
  function syncState() {
    var list = completeItems(), n = list.length;
    $('gr-count').textContent = rows.children.length + ' ' + (rows.children.length === 1 ? I.prod1 : I.prod);
    var label = n ? I.request : I.build;
    var statusTxt = n ? n + ' ' + (n === 1 ? I.prod1 : I.prod) + ' ' + I.in_list : I.status_empty;

    $('gr-status').textContent = statusTxt;
    $('gr-status').classList.toggle('has-items', n > 0);
    $('gr-bar-status').textContent = statusTxt;

    var main = $('gr-primary-cta'), bar = $('gr-bar-cta');
    [main, bar].forEach(function (b) {
      b.querySelector('span').textContent = label;
      b.classList.toggle('js-gr-request', n > 0);
      b.classList.toggle('js-gr-build', n === 0);
    });

    $('gr-empty').hidden = n > 0;
    $('gr-filled').hidden = n === 0;
    if (n) {
      $('gr-preview').innerHTML = list.map(function (i) {
        var b = i.brand === 'specific' ? esc(i.brand_name || 'brand') : i.brand === 'cheapest' ? 'cheapest' : '';
        return '<li><span>' + esc(i.product) + '</span>' + (b ? '<span class="b">' + b + '</span>' : '') +
          '<span class="q">' + esc(i.amount) + ' ' + esc(i.unit) + '</span></li>';
      }).join('');
      $('gr-request-sub').textContent = n + ' ' + (n === 1 ? I.prod1 : I.prod) + ' · ' + I.sub_tail;
    }
  }

  /* ---------- modals ---------- */
  function open(id) { $(id).hidden = false; document.body.style.overflow = 'hidden'; }
  function close(el) { el.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.js-gr-build, .js-gr-request, [data-close]');
    if (!t) {
      if (e.target.classList && e.target.classList.contains('aia-gr2__overlay')) { close(e.target); syncState(); }
      return;
    }
    if (t.hasAttribute('data-close')) { close(t.closest('.aia-gr2__overlay')); syncState(); return; }
    if (t.classList.contains('js-gr-request')) { clearError(); open('gr-request'); }
    else {
      open('gr-builder');
      var cat = t.getAttribute && t.getAttribute('data-category');
      if (cat) {
        var target = null;
        Array.prototype.forEach.call(rows.children, function (n) {
          if (!target && !readRow(n).category && !readRow(n).product) target = n;
        });
        if (!target) target = addRow();
        var sel = target.querySelector('[data-f="category"]');
        sel.value = cat; syncRow(target);
        target.querySelector('[data-f="product"]').focus();
        saveDraft(); syncState();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.aia-gr2__overlay:not([hidden])').forEach(close);
    syncState();
  });
  $('gr-builder-done').addEventListener('click', function () { close($('gr-builder')); saveDraft(); syncState(); });

  /* ---------- coverage / map ---------- */
  var DEFAULT_COVERAGE = { type: 'Polygon', coordinates: [[
    [31.55, 36.72], [32.16, 36.72], [32.16, 36.44], [31.55, 36.44], [31.55, 36.72]
  ]] };
  var coverage = DEFAULT_COVERAGE;
  try { if (cfg.coverage) coverage = JSON.parse(cfg.coverage); } catch (e) {}
  if (coverage.type === 'Feature') coverage = coverage.geometry;

  function pointInRing(pt, ring) {
    var x = pt[0], y = pt[1], inside = false;
    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
      var xi = ring[i][0], yi = ring[i][1], xj = ring[j][0], yj = ring[j][1];
      var hit = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (hit) inside = !inside;
    }
    return inside;
  }
  function inCoverage(lng, lat) {
    var polys = coverage.type === 'MultiPolygon' ? coverage.coordinates : [coverage.coordinates];
    return polys.some(function (p) {
      if (!pointInRing([lng, lat], p[0])) return false;
      for (var h = 1; h < p.length; h++) if (pointInRing([lng, lat], p[h])) return false;
      return true;
    });
  }
  var map, marker, geocoder;
  var MAP_TOP = !!$('gr-map-top');
  function mapEl() { return MAP_TOP ? $('gr-map-top') : $('gr-map'); }
  function addrEl() { return MAP_TOP ? $('gr-address-top') : $('gr-address'); }
  function checkEl() { return MAP_TOP ? $('gr-check-top') : $('gr-check'); }
  var ADDR_KEY = 'aia_gr_addr_v1';
  function savedAddr() { try { return JSON.parse(localStorage.getItem(ADDR_KEY) || 'null'); } catch (e) { return null; } }
  function initMap() {
    var g = window.google.maps;
    map = new g.Map(mapEl(), {
      center: { lat: 36.57, lng: 31.92 }, zoom: 11, minZoom: 10, maxZoom: 16,
      disableDefaultUI: true, zoomControl: true, gestureHandling: 'cooperative',
      restriction: { latLngBounds: { north: 36.80, south: 36.36, west: 31.40, east: 32.30 }, strictBounds: false }
    });
    geocoder = new g.Geocoder();
    var input = addrEl();
    try {
      var ac = new g.places.Autocomplete(input, {
        componentRestrictions: { country: 'tr' }, fields: ['geometry', 'name', 'formatted_address'],
        bounds: new g.LatLngBounds({ lat: 36.44, lng: 31.55 }, { lat: 36.72, lng: 32.16 }), strictBounds: true
      });
      ac.addListener('place_changed', function () {
        var p = ac.getPlace(); if (p && p.geometry) showResult(p.geometry.location, p.name || p.formatted_address);
      });
    } catch (e) { /* legacy Places unavailable; button + Geocoding still work */ }
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkEl().click(); } });
    // step-by-step fields: neighbourhood / street / building, each Google-backed
    try {
      var baseBounds = new g.LatLngBounds({ lat: 36.44, lng: 31.55 }, { lat: 36.72, lng: 32.16 });
      var stepTypes = { nb: ['(regions)'], st: ['geocode'], bl: ['establishment'] };
      var stepAcs = {};
      document.querySelectorAll('.gr-step').forEach(function (el) {
        var kind = el.getAttribute('data-step');
        var ac2 = new g.places.Autocomplete(el, {
          types: stepTypes[kind], componentRestrictions: { country: 'tr' },
          bounds: baseBounds, strictBounds: true,
          fields: ['geometry', 'name', 'formatted_address']
        });
        stepAcs[kind] = ac2;
        ac2.addListener('place_changed', function () {
          var p = ac2.getPlace(); if (!p || !p.geometry) return;
          showResult(p.geometry.location, p.name || p.formatted_address);
          if (kind === 'nb' && p.geometry.viewport) {
            if (stepAcs.st) stepAcs.st.setBounds(p.geometry.viewport);
            if (stepAcs.bl) stepAcs.bl.setBounds(p.geometry.viewport);
          }
        });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      });
    } catch (e) { /* Places unavailable: main search still works */ }
    var sa = savedAddr();
    if (sa) {
      input.value = sa.label || '';
      setZone(sa.status === 'in' ? 'ok' : 'no', (sa.label || '') + (sa.status === 'in' ? ' \u00b7 ' + I.deliver_ok : ' \u00b7 ' + I.deliver_no));
      $('gr-zone-lat').value = sa.lat || ''; $('gr-zone-lng').value = sa.lng || '';
      if (sa.lat) {
        marker = new g.Marker({ map: map, position: { lat: +sa.lat, lng: +sa.lng } });
        map.setCenter({ lat: +sa.lat, lng: +sa.lng }); map.setZoom(14);
      }
    }
    checkEl().addEventListener('click', function () {
      var q = input.value.trim(); if (!q) return;
      geocoder.geocode({ address: q + ', Alanya, Antalya, Turkey', bounds: new google.maps.LatLngBounds({ lat: 36.44, lng: 31.55 }, { lat: 36.72, lng: 32.16 }) }, function (res, status) {
        if (status === 'OK' && res[0]) showResult(res[0].geometry.location, res[0].formatted_address);
        else setZone('no', I.not_found);
      });
    });
  }
  function showResult(loc, label) {
    var lat = loc.lat(), lng = loc.lng();
    var ok = inCoverage(lng, lat);
    if (!marker) marker = new google.maps.Marker({ map: map });
    marker.setPosition(loc); map.panTo(loc); map.setZoom(14);
    $('gr-zone-lat').value = lat.toFixed(5); $('gr-zone-lng').value = lng.toFixed(5);
    if (ok) {
      setZone('ok', label + ' · ' + I.deliver_ok);
      if (!$('gr-hotel').value) $('gr-hotel').value = label;
    } else {
      setZone('no', label + ' · ' + I.deliver_no);
    }
    try { localStorage.setItem(ADDR_KEY, JSON.stringify({ label: label, lat: lat.toFixed(5), lng: lng.toFixed(5), status: ok ? 'in' : 'out' })); } catch (e) {}
    track('zone_check', { zone_status: ok ? 'in' : 'out', lead_source: cfg.leadSource || 'generic' });
  }
  function setZone(state, msg) {
    var el = $('gr-zone-result');
    el.className = 'aia-gr2__zone-result ' + (state === 'ok' ? 'is-ok' : 'is-no');
    el.textContent = msg;
    $('gr-zone-status').value = state === 'ok' ? 'in' : 'out';
    syncMapResult(state, msg);
  }
  function syncMapResult(state, msg) {
    var box = $('gr-mapresult'); if (!box) return;
    box.hidden = false;
    box.className = 'aia-gr2__mapresult ' + (state === 'ok' ? 'is-ok' : 'is-no');
    $('gr-mapresult-text').textContent = msg;
    $('gr-mapresult-cta').hidden = state !== 'ok';
  }
  if (cfg.mapsKey) {
    window.aiaGrInitMap = initMap;
    var sc = document.createElement('script');
    sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(cfg.mapsKey) + '&libraries=places&callback=aiaGrInitMap&loading=async&language=' + encodeURIComponent((document.documentElement.lang || 'en').slice(0, 2));
    sc.async = true; document.head.appendChild(sc);
  } else {
    mapEl().style.display = 'none';
    checkEl().addEventListener('click', function () { setZone('ok', I.wa_confirm); });
  }

  /* ---------- validation + submit ---------- */
  function showError(msg) { err.textContent = msg; err.hidden = false; }
  function clearError() { err.hidden = true; err.textContent = ''; }
  function validate(d) {
    var bad = [];
    form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    if (!completeItems().length) bad.push(I.e_item);
    if (!d.name) { bad.push(I.e_name); $('gr-name').classList.add('is-invalid'); }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) { bad.push(I.e_email); $('gr-email').classList.add('is-invalid'); }
    var digits = d.phone.replace(/\D/g, '');
    if (digits.length < 6 || (d.cc === 'other' && !/^\+/.test(d.phone))) { bad.push(I.e_phone); $('gr-phone').classList.add('is-invalid'); }
    if (!d.hotel) { bad.push(I.e_hotel); $('gr-hotel').classList.add('is-invalid'); }
    if (!d.date) { bad.push(I.e_date); $('gr-date').classList.add('is-invalid'); }
    return bad;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if ($('gr-hp').value) return;
    clearError();
    var d = collect();
    var bad = validate(d);
    if (bad.length) { showError(I.err_add + ' ' + bad.join(', ') + '.'); return; }
    d.items = completeItems();
    d.phone_full = d.cc === 'other' ? d.phone : d.cc + ' ' + d.phone;
    d.zone_status = $('gr-zone-status').value;
    d.zone_lat = $('gr-zone-lat').value; d.zone_lng = $('gr-zone-lng').value;
    d.page = cfg.pageUrl; d.lang = document.documentElement.lang || 'en';
    d.lead_source = cfg.leadSource || 'generic';
    d.utm = location.search.slice(1);
    var btn = $('gr-send'); btn.disabled = true;
    fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        try { localStorage.removeItem(DRAFT_KEY); } catch (x) {}
        track('generate_lead', { lead_type: 'grocery_request', lead_source: d.lead_source, items: d.items.length });
        location.href = cfg.thanksUrl + '?src=' + encodeURIComponent(d.lead_source) + '&ref=' + encodeURIComponent(d.date + '_' + d.slot);
      })
      .catch(function () {
        btn.disabled = false;
        showError(I.send_fail);
      });
  });
  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params));
  }

  syncState();
})();
